import React from "react";

const ExperienceCards = () => {
  const stats = [
    { number: "25+", label: "Years of Experience" },
    { number: "98%", label: "Satisfaction" },
    { number: "1K+", label: "Happy Customers" },
    { number: "80+", label: "Retailers" },
  ];

  return (
    <section className="bg-[#f0f9ff] py-16">
      <div className="container mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 text-center">
          {stats.map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-b from-[#b7dbf0] to-[#4a89c4] rounded-xl py-10 shadow-md hover:shadow-xl hover:scale-105 transition-all duration-300 cursor-pointer"
            >
              <h3 className="text-white text-5xl font-extrabold mb-2">
                {item.number}
              </h3>
              <p className="text-white text-lg">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExperienceCards;